import { cn } from "@/lib/cn";
import { INTEGRATIONS } from "@/shared/data";
import Checkbox from "@components/ui/checkbox";
import Icon from "@components/ui/icon";
import Popover from "@components/ui/popover";
import { useMemo, useState } from "react";
import type { FormHandlers } from "../types";

export const Integrations = ({
  property,
  register,
  setValue,
  watch,
}: FormHandlers) => {
  const [isOpen, setIsOpen] = useState(false);
  const current = (watch(property) || []) as string[];
  const selected = useMemo(() => {
    const res = INTEGRATIONS.filter((i) =>
      current.includes(i.internalName),
    ).map((i) => i.title);
    if (current.includes("fathom")) {
      res.push("Fathom");
    }
    return res;
  }, [current]);

  return (
    <div
      className="tw-relative tw-mt-4 [&_.WsA9Pt7X1Xr2kTA-content]:tw-w-full"
      {...register("allowedIntegrations")}
    >
      <span className="tw-mb-1 tw-font-sans tw-text-[13px]/normal tw-font-semibold tw-text-blue-base">
        Allowed integrations
      </span>

      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <Popover.Trigger
          className={
            "tw-flex tw-h-9 tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-rounded tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-px-3 tw-py-1 tw-font-sans tw-text-xs tw-font-normal tw-text-blue-base"
          }
        >
          <span className="tw-block tw-w-[93%] tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap">
            {selected.join(", ")}
          </span>
          <Icon
            icon="ri-arrow-down-s-fill"
            className={cn("tw-text-xl/none", {
              "tw-rotate-180 tw-transition-transform": isOpen,
            })}
          />
        </Popover.Trigger>
        <Popover.Content className="tw-z-[99999]">
          <Select
            property="allowedIntegrations"
            setValue={setValue}
            watch={watch}
          />
        </Popover.Content>
      </Popover>
    </div>
  );
};

const Select = ({
  property,
  setValue,
  watch,
}: Omit<FormHandlers, "register">) => {
  const current = (watch(property) || []) as string[];
  const integrations = useMemo(() => {
    const res = INTEGRATIONS.filter((i) => i.available).map((i) => ({
      title: i.title,
      value: i.internalName,
    }));

    return [...res, { title: "Fathom", value: "fathom" }];
  }, []);

  return (
    <div className="scrollbar tw-flex tw-max-h-40 tw-w-full tw-flex-col tw-gap-2 tw-overflow-y-auto tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-p-2 tw-shadow-sm">
      {integrations.map((i) => (
        <Checkbox
          checked={current.includes(i.value)}
          key={i.value}
          onCheckedChange={() => {
            const newValue = current.includes(i.value)
              ? current.filter((c) => c !== i.value)
              : [...current, i.value];
            setValue(property, newValue);
          }}
        >
          <Checkbox.Toggle />
          <Checkbox.Label>{i.title}</Checkbox.Label>
        </Checkbox>
      ))}
    </div>
  );
};
